/**
 * Runtime configuration for the sync engine.
 *
 * Web reads `import.meta.env.VITE_PARTYKIT_HOST` (Vite-specific). Metro/React
 * Native cannot resolve `import.meta.env` and would fail at parse time. Both
 * platforms call `setPartykitHost(...)` once at startup; the engine reads
 * the value lazily through `getPartykitHost()` so the platform-specific
 * resolution stays at the edges.
 */

const DEFAULT_PARTYKIT_HOST = 'localhost:8787';

let _partykitHost: string = DEFAULT_PARTYKIT_HOST;

/**
 * Register the PartyKit / partyserver host (e.g.
 * `flashka-sync.your-account.workers.dev` or `localhost:8787`).
 *
 * Must be called before any sync provider mounts. Idempotent.
 */
export function setPartykitHost(host: string | null | undefined): void {
  _partykitHost = host && host.length > 0 ? host : DEFAULT_PARTYKIT_HOST;
}

/** Read the registered PartyKit host. Defaults to `localhost:8787`. */
export function getPartykitHost(): string {
  return _partykitHost;
}
